export default "__VITE_ASSET__BtENhG2a__"